import React from 'react';
import moment from 'moment';

import ParticipantChatNameComponent from '../chatComponents/participantChatNameComponent';
import PlaySoundTriangleIcon from '../../assets/svgComponents/PlaySoundTriangleIcon';
import SoundWaveIcon from '../../assets/svgComponents/SoundWaveIcon';
import StopIcon from '../../assets/svgComponents/StopIcon';

import VIDABOO_CONSTANTS from '../../config/consts';
import arrowIcon from '../../assets/svg/icons/right-arrow.svg';

import MediaMessageService from '../../services/restServices/mediaMessageService';

import './getMediaMessage.css';

//isigal
const AUDIO_DL_STATES = {
  INIT: 'INIT',
  DOWNLOADING: 'DOWNLOADING',
  FINISHED: 'FINISHED_DOWNLOAD',
};
class GetVoiceMsgComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tempUrl: undefined,
      voiceMsgDuration: undefined,
      audioDownloadedState: AUDIO_DL_STATES.INIT,
      voiceSendTime: '',
    };
    this.msgWasDownloaded = false;
    this.voiceContainerRef = React.createRef();
  }

  togglepLay = () => {
    if (this.msgWasDownloaded) {
      if (this.audioEl.paused) {
        // console.debug('paused');
        this.audioEl['play']();
        this.setState({isPlaying: true});

        //isigal - there is a need to add pause image
        //and switch between images accordingly
      } else {
        // console.debug('play');
        this.setState({isPlaying: false});

        this.audioEl['pause']();
      }
    } else {
      this.setState({audioDownloadedState: AUDIO_DL_STATES.DOWNLOADING});
      this.getVoiceMsgByMsgId(this.props.voiceMsgId);
    }
  };
  componentDidUpdate = () => {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      return;
    }
    if (
      this.state.waveSoundWidth !== this.voiceContainerRef.current.offsetWidth
    ) {
      let waveSoundWrapperWidth = this.voiceContainerRef.current.offsetWidth;
      this.setState({
        waveSoundWidth: waveSoundWrapperWidth,
      });
    }
  };
  componentDidMount() {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      return;
    }

    let waveSoundWrapperWidth = this.voiceContainerRef.current.offsetWidth;

    this.audioEl = document.getElementById(
      'et-voice-msg-audio-id' + this.props.voiceMsgId,
    );
    this.setState({
      waveSoundWidth: waveSoundWrapperWidth,
    });
    if (this?.props?.type === 'media') {
      const sendTime = moment(this.props.message.senderCreationTime).format(
        'h:mm A',
      );

      this.audioEl = document.getElementById(
        'et-voice-msg-audio-id' + this.props.voiceMsgId + 'media',
      );
      this.setState({
        voiceSendTime: sendTime,
      });
    }
    this.audioEl.addEventListener('loadedmetadata', () => {
      // waiting till browser's audio component finished loading. The indication is that the meta data is ready.
      this.setState({});

      this.setState({
        voiceMsgDuration: Math.round(this.audioEl.duration),
        audioDownloadedState: AUDIO_DL_STATES.FINISHED,
      });
    });

    this.togglepLay();
  }
  componentWillUnmount = () => {
    clearInterval(this.blinkingInterval);
  };

  updateBar = () => {
    let isPlaying = this.state.isPlaying;
    let audiopercentsProgress =
      this.audioEl.currentTime / this.audioEl.duration;

    let width = this.voiceContainerRef.current.offsetWidth;

    let noiseImgWidth = width * audiopercentsProgress + 'px';

    let movingBallLeft = 0;
    if (width * audiopercentsProgress < (width * 10) / 100) {
      movingBallLeft = '0px';
    } else if (width * audiopercentsProgress > width - (width * 10) / 100) {
      movingBallLeft = width - 15 + 'px';
    } else {
      // console.debug("in the right place");
      movingBallLeft = audiopercentsProgress * width + 'px';
      // console.debug(movingBall.style.left);
    }
    if (width * audiopercentsProgress === width) {
      movingBallLeft = '0px';
      // noiseImg.style.width = '0px';
      isPlaying = false;
    }
    this.setState({noiseImgWidth, movingBallLeft, isPlaying});
  };

  getVoiceMsgByMsgId = async (voiceMsgId) => {
    //let HOST = "http://localhost:8080";
    //let {data: mediaMessageDto} = await http.get(HOST+'/mediaMessage/mediaMessageId/'+voiceMsgId);
    //console.debug("calling getVoiceMsg");
    // this.blinkColor("et-play-voice-msg-btn-" + this.props.voiceMsgId);
    let tempAccessibleUrl;
    if (this.props.isDemo) {
      tempAccessibleUrl = this.props.demoVoiceMsgLink;
    } else {
      tempAccessibleUrl =
        await MediaMessageService.getVoiceMsgByMsgId(voiceMsgId);
    }

    // let mediaMessageDto = dataFromServer.data.mmDto;
    //let base64VoiceMsg = mediaMessageDto.voiceMsgBase64;
    //this.tempUrl = dataFromServer.data.mmDto.tempAccessibleUrl;
    this.setState({tempUrl: tempAccessibleUrl});
    this.msgWasDownloaded = true;
    //audioToPlay = new Audio("data:audio/webm;base64," + base64VoiceMsg);
    //console.debug("Url: " + this.tempUrl);

    //this.audioToPlay = new Audio(this.tempUrl)
    //snd.play();
  };

  playAudioMsg = () => {
    this.audioToPlay.play();
    this.setState({isPlaying: true});
  };

  render() {
    const {voiceSendTime} = this.state;
    return (
      <div
        className={`et-n-get-voice-msg-container ${
          this.props.type === 'media'
            ? 'et-n-get-voice-msg-media-container'
            : ''
        }`}>
        <audio
          src={this.state.tempUrl}
          onTimeUpdate={this.updateBar}
          id={
            'et-voice-msg-audio-id' +
            this.props.voiceMsgId +
            `${this.props.type === 'media' ? 'media' : ''}`
          }></audio>
        <div className="et-n-drm-bot">
          <div
            className={` ${this.props.participantName ? 'et-n-drmb-with-name' : ''} ${
              this.props.align === 'right'
                ? 'et-n-drmb-ind-right'
                : 'et-n-drmb-ind-left'
            }`}>
            {this.props.participantName && (
              <ParticipantChatNameComponent
                participantName={this.props.participantName}
              />
            )}
            <div className="et-n-drmbi-content-wrap">
              <div className="et-n-drmbi-left">
                <div className="et-n-drmbil-top" onClick={this.togglepLay}>
                  {this.state.isPlaying ? (
                    <StopIcon />
                  ) : (
                    <div
                      className={
                        this.state.audioDownloadedState ===
                        AUDIO_DL_STATES.DOWNLOADING
                          ? 'et-n-drmbil-download-anim'
                          : 'et-n-drmbil-img'
                      }>
                      <PlaySoundTriangleIcon />
                    </div>
                  )}
                </div>
              </div>
              <div className="et-n-drmbi-right">
                <div className="et-n-drmbir-top" ref={this.voiceContainerRef}>
                  <div
                    id={'et-n-unplayed-img-id-' + this.props.voiceMsgId}
                    className="et-n-drmbirt-img-unplayed">
                    {this.state.voiceMsgDuration && (
                      <SoundWaveIcon
                        fillColor="#A8C0FA"
                        width={this.state.waveSoundWidth}
                      />
                    )}
                  </div>
                </div>
                <div
                  id={'et-noise-img-id-' + this.props.voiceMsgId}
                  className="et-n-drmbirt-img-played"
                  style={{width: this.state.noiseImgWidth}}>
                  {this.state.isPlaying && (
                    <SoundWaveIcon
                      fillColor={
                        this.props.align === 'right' ? '#fff' : '#2961FA'
                      }
                      width={this.state.waveSoundWidth}
                    />
                  )}
                </div>

                <div
                  style={{left: this.state.movingBallLeft}}
                  id={
                    'et-progress-bar-ball-id-' +
                    this.props.voiceMsgId +
                    `${this.props.type === 'media' ? 'media' : ''}`
                  }
                  className={`et-n-progress-bar-ball ${
                    this.props.align === 'right'
                      ? 'et-n-progress-bar-ball-right'
                      : ''
                  }`}></div>
              </div>
              {this.state.voiceMsgDuration && (
                <div
                  className={`et-n-drmbil-bot ${
                    this.props.align === 'right' ? 'et-n-drmbil-bot-right' : ''
                  }`}>
                  {this.state.voiceMsgDuration >= 0 &&
                  this.state.voiceMsgDuration < 10
                    ? '00:0' + this.state.voiceMsgDuration
                    : '00:' + this.state.voiceMsgDuration}
                </div>
              )}
            </div>
          </div>
          {this.props.type === 'media' && (
            <div className="et-n-pm-wrap">
              <img
                onClick={() => this.props.goToMessage(this.props.chatMessageId)}
                src={arrowIcon}
                className="et-n-drmbil-arrow-img"
                alt="arrowIcon"
              />
              <div className="et-n-pm-time-format-wrap">
                {this.state.voiceMsgDuration && (
                  <p className="et-n-pm-message-time">
                    {this.state.voiceMsgDuration}secs
                  </p>
                )}{' '}
                <p className="et-n-pm-message-time">{voiceSendTime}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default GetVoiceMsgComponent;
